<template>
	<div class="detail-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home">
				<i class="n el-icon-s-home"></i>
				首页
			</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/cms/help' }">帮助列表</el-breadcrumb-item>
			<el-breadcrumb-item class="path-help">帮助详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="help-detail" v-loading="loading">
			<div class="title">{{ detail.title }}</div>
			<div class="info">
				<div class="time">{{ $util.timeStampTurnTime(detail.create_time) }}</div>
			</div>
			<div class="content" v-html="detail.content"></div>
			<div class="content">
				<h3><span style="line-height:2.5"><span style="font-size:18px">一、我们如何收集和使用您的个人信息</span></span></h3>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">为向您提供网上购物服务，我们的基本功能包括<strong>账号注册登录、商品/服务信息展示、下单及订单管理、支付、商品/服务交付、客服与售后、交易安全保障</strong>。在您使用上述功能过程中，我们会收集使用下列与您有关的信息，<strong>如您不提供相应信息，您将无法正常使用我们的产品与/或服务</strong>。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000"><span
							style="background-color:#ffffff">除基本功能外，我们还为您提供部分附加功能，包括<strong>基于权限的购物体验提供服务</strong>以及<strong>信息公开发布功能</strong>。您可选择单独同意或不同意我们收集使用的这部分涉及的个人信息，<strong>如您拒绝提供，您将无法正常使用相关附加功能，但不会影响您使用我们的基本功能。</strong></span></span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000"><strong><span
								style="background-color:#ffffff">请您理解，因不同用户选择使用的产品/服务版本、范围有所不同，如具体功能展示的收集使用规则与本隐私政策存在差异，请以具体功能展示的内容为准。</span></strong>我们为您提供的功能场景及收集使用的个人信息具体如下：</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（一）账号注册登录</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">当您注册使用承热惠家服务时，您需要向我们提供<strong>手机号码</strong>，我们将通过发送短信验证码来验证您的身份是否有效，通过SIM卡信息识别并显示对应的运营商。您的账号名为您的默认昵称，</span>您可以自主选择修改和补充您的<span
						style="color:#000000"><strong>昵称、头像、账号名</strong></span>以及您的实名认证相关信息，这些信息均属于您的<span
						style="color:#000000"><strong>“账号信息”</strong>。</span></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">注册完成后，您可以选择使用<strong>承热惠家账号信息</strong>或者授权我们获取您的<strong>第三方账号信息</strong>进行登录，若您不提供这类信息，您将无法登录和使用我们的产品与/或服务，此时您可使用浏览和搜索功能，我们将不会收集您的上述个人信息。</span>
				</p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（二）商品/服务信息展示</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000"><span
							style="background-color:#ffffff">为了向您提供搜索历史、浏览记录、收藏的商品或店铺、关注的店铺、购物车或订单商品或服务展示服务，在使用过程中，我们会收集您的<strong>浏览信息、搜索记录、收藏记录、关注记录、加购信息、订单信息</strong>。其中，在向您提供展示搜索历史服务时，搜索记录信息存储在您的本地设备。</span></span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">为了向您提供搜索历史、浏览记录、收藏的商品或店铺、关注的店铺、购物车或订单商品或服务展示服务，我们会收集您的<strong>浏览信息、搜索记录、收藏记录、关注记录、加购信息、订单信息</strong>。</span>
				</p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（三）下单及订单管理</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">当您选择对商品/服务进行结算时，承热惠家会生成您购买商品的订单。您需要在订单中至少填写您的<strong>收货人姓名、收货地址以及手机号码</strong>，同时该订单中会载明<strong>订单号、您所购买的商品或服务信息、下单时间、您应支付的货款金额及支付方式</strong>。您可以另外填写<strong>收货人的联系电话、邮箱、邮编</strong>以增加更多的联系方式确保商品可以准确送达，不填写这些信息不影响您订单的生成。若您需要开具发票，还需要提供<strong>发票抬头、纳税人识别号以及接收发票的邮箱</strong>。</span>
				</p>
				<p style="text-indent:2em;" class="MsoNormal"><span
						style="color:#000000">上述所有信息构成您的<strong>“订单信息”</strong>，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保障您的交易安全。</span>
				</p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（四）支付功能</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">在您下单后，您可以选择承热惠家的关联方或与承热惠家合作的第三方支付机构（包括微信支付及银联、网联及其他支付通道，以下称“支付机构”）所提供的支付服务。<strong>我们需要将您的承热惠家订单号与交易金额信息与这些支付机构共享以完成下单支付功能。</strong>在您使用支付功能时，支付机构会通过其页面收集或验证您的银行卡（含储蓄卡、信用卡）及其他支付必要信息，以实现其确认您的支付指令并完成支付，具体适用各支付机构相应的隐私政策。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000"><span
							style="background-color:#ffffff">为了解您的支付进度及状态，我们会向您所选择的支付机构收集相应的<strong>支付信息，</strong>包括<strong>支付时间、支付方式、支付金额</strong>。</span></span>
				</p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（五）商品/服务交付</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">当您下单完成，或获取试用品、奖品后，承热惠家、承热惠家的关联方、供应商、与承热惠家合作的商家或配送公司将为您完成订单的交付。您知晓并同意，<strong>承热惠家、承热惠家的关联方、供应商、与承热惠家合作的商家或配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。</strong></span>
				</p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（六）客服与售后</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">我们的电话客服和售后功能会使用您的<strong>账号信息</strong>和<strong>订单信息</strong>。为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的<strong>账号信息</strong>与您核验您的身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的<strong>订单信息</strong>。另外，您在申请退款或退货时，我们需要收集您的<strong>联系人、联系方式以及退货地址</strong>，以保障完成相应的售后服务。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">若您有获赠或购买商品运费险，您在退换货时所产生的运费可能申请由运费险服务提供商进行赔付，为实现投保和理赔，我们将收集或查询<strong>您购买商品的质保起止期、退换货商品快递公司、快递单号、退货地址、投递时间信息</strong>。</span>
				</p>
				<p> </p>
				<hr />
				<h3><span style="line-height:3"><span style="font-size:20px">二、我们如何使用Cookies和同类技术</span></span></h3>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">1、Cookies的使用</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">在您使用我们的服务过程中，我们会在您的计算机上发送一个或多个名为Cookies的小数据文件，目的是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账号或数据安全。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">您可以清除计算机上保存的所有 Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
						Cookies。如果您这么做，您可能需要在每一次访问承热惠家网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</span>
				</p>
				<p></p>
				<hr />
				<h3><span style="line-height:3"><span style="font-size:20px">三、我们如何对外提供您的个人信息</span></span></h3>
				<p style="text-align:left;text-indent:2em;"><strong><span style="color:#000000">（一）共享</span></strong>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">1、我们不会与承热惠家以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</span></strong><br /> <span
						style="color:#000000">（1）事先获得您明确的同意或授权；</span></p>
				<p><span style="color:#000000">（2）根据法律法规、行政及司法部门强制性要求进行提供；</span></p>
				<p><span style="color:#000000">（3）应您需求为您处理您与他人的纠纷或争议；</span></p>
				<p><span style="color:#000000">（4）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</span></p>
				<p><span style="color:#000000">（5）基于符合法律法规的社会公共利益、突发公共卫生事件而使用。</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000"><strong>2、为向您提供相关产品或服务，向您展示可能感兴趣的内容，保护您的账号与交易安全，我们可能会将您的个人信息与我们的关联方或者合作伙伴共享，共享内容及目的<a
								href="https://h5.m.jd.com/babelDiy/Zeus/2TUXHKBMgpgckQbcrDvhX4mxjLc7/index.html"
								target="_blank">详见此处</a></strong>。</span> </p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">请您注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或第三方的个人信息甚至敏感个人信息，请您共享时谨慎考虑并决定。如涉及第三方个人信息，请<span
								style="background-color:#ffffff">您确保您已经取得合法的授权。</span></span></strong></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"> </p>

				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（二）公开披露</span></strong></p>
				<p><span style="color:#000000">我们仅会在以下情况，且在采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：</span></p>
				<p><span style="color:#000000">（1）根据您单独同意的授权范围披露相应个人信息；</span></p>
				<p><span
						style="color:#000000">（2）<strong>如果您严重违反法律法规或者相关协议、规则，我们可能会披露您的相关违规行为及我们对您采取的措施</strong>。</span>
				</p>
				<p> </p>
				<hr />
				<h3><span style="line-height:3"><span style="font-size:20px">四、我们如何保护和保存您的个人信息</span></span></h3>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（一）我们保护您个人信息的技术与措施</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoListParagraph" align="left"><strong><span
							style="color:#000000">1、</span></strong> <strong><span
							style="color:#000000">数据安全技术措施</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。例如：承热惠家的网络服务采取了传输层安全协议加密技术，通过https方式提供浏览服务，确保用户数据在传输过程中的安全；在个人信息处理时，我们会采用包括内容替换、SHA256在内多种数据脱敏技术增强个人信息在使用中安全性。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">2、承热惠家为保护个人信息采取的其他安全措施</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">承热惠家通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用；通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制；承热惠家建立数据安全委员会并下设信息保护专职部门、数据安全应急响应组织来推进和保障个人信息安全。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">我们存储您个人信息的底层云技术取得了数据中心联盟颁发的“可信云”认证三级认证、通过了公安部安全等级保护三级认证，同时还获得了ISO27000认证。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">3、安全事件处置</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。</span></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">一旦发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。同时，我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
				</p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"> </p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><strong><span
							style="color:#000000">（二）您个人信息的保存</span></strong></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">1、您的个人信息将存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独获取您的授权同意并要求接收方按照双方签署的数据保护协议、本隐私政策以及相关法律法规要求来处理您的个人信息。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">2、在您使用我们的产品与/或服务期间，您的个人信息将在为了实现本政策所述目的之期限内保存，同时将结合法律有强制的留存要求期限的规定确定，如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在超出保存期间后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。</span>
				</p>
				<p></p>
				<hr />
				<h3><span style="line-height:3"><span style="font-size:20px">五、通知和修订</span></span></h3>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">1、为给您提供更好的服务以及随着承热惠家业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在承热惠家网站、承热惠家移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问承热惠家以便及时了解最新的隐私政策。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</span>
				</p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">本隐私政策所指的重大变更包括但不限于：</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">（3）个人信息共享、转移或公开披露的主要对象发生变化；</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span></p>
				<p></p>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">（6）个人信息安全影响评估报告表明存在高风险时。</span></p>
				<p></p>
				<hr />
				<h3 style="text-align:start;" size="4" _root="[object Object]" __ownerid="undefined" __hash="undefined"
					__altered="false"><span style="font-size:20px">六、如何联系我们</span></h3>
				<p style="text-align:left;text-indent:2em;" class="MsoNormal" align="left"><span
						style="color:#000000">如您有任何疑问、意见或建议，您可通过以下联系方式与我们联系：</span></p>
				<p style="text-indent:2em;"><span style="color:#000000">联系电话：0314-966866</span></p>
				<!-- <p style="text-indent:2em;"><span style="color:#000000">联系邮箱：brxm@heatingpay.com</span></p> -->
				<!-- <p style="text-indent:2em;"><span style="color:#000000">注册地址：辽宁省沈阳市和平区三好街100-4号（7-14）</span></p> -->
				<p style="text-indent:2em;"><span style="color:#000000">常用办公地址：中国河北承德市半壁山路18号 </span></p>

				<p></p>
			</div>
		</div>
	</div>
</template>

<script>
import { helpDetail } from '@/api/cms/help';
export default {
	name: 'help_detail',
	components: {},
	data: () => {
		return {
			detail: [],
			loading: true,
			content: ``
		};
	},
	created() {
		this.id = this.$route.path.replace('/cms/help-', '');
		this.getDetail();
	},
	watch: {
		$route(curr) {
			this.id = curr.params.pathMatch;
			this.getDetail();
		}
	},
	methods: {
		getDetail() {
			helpDetail({
				id: this.id
			})
				.then(res => {
					if (res.code == 0) {
						if (res.data) {
							this.loading = false;
							this.detail = res.data;
						} else {
							this.$router.push({ path: '/cms/help' });
						}
					}
				})
				.catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.help-detail {
	background-color: #ffffff;
	padding: 10px;
	border-radius: 5px;
	margin: 10px 0;

	.title {
		text-align: center;
		font-size: 18px;
		margin: 10px 0;
	}

	.info {
		margin: 0 43px;
		border-bottom: 1px dotted #e9e9e9;

		.time {
			text-align: center;
			color: #838383;
			margin-bottom: 17px;
		}
	}

	.content {
		padding-top: 10px;
		margin: 0 65px;
	}
}

.path {
	padding: 15px 0;
}
</style>
